import React from 'react'

import CreditApproval from '../components/credit-approval'

class CreditApprovalPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<CreditApproval />
			</div>
		)
	}

}

export default CreditApprovalPage;


// WEBPACK FOOTER //
// ./src/containers/credit-approval-page.js